import { ChevronDown, Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "../../assets/logo.png";

const navLinks = [
  { label: "Home", href: "#" },
  { label: "About", href: "#about" },
  {
    label: "Services",
    href: "#services",
    dropdown: [
      { label: "Bookkeeping", href: "#services" },
      { label: "GST / TDS", href: "#services" },
      { label: "Canadian Tax", href: "#services" },
      { label: "Payroll", href: "#services" },
      { label: "Financial Statements", href: "#services" },
      { label: "Cloud Data", href: "#services" },
      { label: "Cash Flow", href: "#services" },
      { label: "Business Advisory", href: "#services" },
    ],
  },
  { label: "Updates", href: "#updates" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50">
      {/* Top info bar */}
      <div className="bg-navy text-white text-[11px] font-manrope font-semibold tracking-widest uppercase">
        <div className="max-w-[1280px] mx-auto px-6 py-2 flex justify-between items-center">
          <span className="opacity-60">
            India: +91 99672 90235 &nbsp;|&nbsp; Canada: +1 403 829 9209
          </span>
          <span className="opacity-60">info@greatcalcy.co.in</span>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-white/90 backdrop-blur-md border-b border-navy/5 shadow-navy-sm">
        <div className="max-w-[1280px] mx-auto px-6 py-4 flex justify-between items-center">
          {/* Logo */}
          <a href="#" className="flex flex-col leading-none">
            <img src={logo} alt="Greatcalcy Logo" className="w-14 md:w-28" />
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.dropdown ? (
                <div
                  key={link.label}
                  className="relative"
                  onMouseEnter={() => setOpenDropdown(true)}
                  onMouseLeave={() => setOpenDropdown(false)}
                >
                  <button className="font-manrope text-[13px] font-bold uppercase tracking-widest text-navy hover:text-gold transition-colors flex items-center gap-1">
                    {link.label}
                    <span className="material-symbols-outlined text-sm"><ChevronDown /></span>
                  </button>
                  {openDropdown && (
                    <div
                      className="absolute top-full left-0 w-52 bg-white rounded-xl shadow-xl border border-outline-variant/20 py-2 z-50">
                      {link.dropdown.map((item) => (
                        <a
                          key={item.label}
                          href={item.href}
                          className="block px-5 py-2.5 font-manrope text-[13px] text-on-surface hover:bg-surface-container-low hover:text-gold transition-colors"
                        >
                          {item.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="font-manrope text-[13px] font-bold uppercase tracking-widest text-navy hover:text-gold transition-colors"
                >
                  {link.label}
                </a>
              )
            )}
          </div>

          <div className="flex items-center gap-3">
            <a
              href="#contact"
              className="hidden md:inline-flex bg-gold text-white px-5 py-2.5 rounded-lg font-manrope font-bold text-[13px] uppercase tracking-widest hover:brightness-110 active:scale-95 transition-all shadow-gold-inset"
            >
              Get In Touch
            </a>
            {/* Mobile hamburger */}
            <button
              className="md:hidden text-navy"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <span className="material-symbols-outlined">
                {mobileOpen ? <X /> : <Menu />}
              </span>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-outline-variant/20 px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="font-manrope text-[13px] font-bold uppercase tracking-widest text-navy hover:text-gold transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
